// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zappyride_incentive_web--SkeletonTable-module--container--Rqeyki6fYhTMAYUOj4B6 {
  padding-top: 24px;
  padding-bottom: 48px;
  margin-bottom: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/SkeletonTable/SkeletonTable.module.scss"],"names":[],"mappings":"AAAA;EACI,iBAAA;EACA,oBAAA;EACA,mBAAA;AACJ","sourcesContent":[".container {\n    padding-top: 24px;\n    padding-bottom: 48px;\n    margin-bottom: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `zappyride_incentive_web--SkeletonTable-module--container--Rqeyki6fYhTMAYUOj4B6`
};
export default ___CSS_LOADER_EXPORT___;
